import * as React from "react";
import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { base64Decode, isValidArray } from "../../Layout/Common/common";
import { QuickOrderMain } from "../QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { useAuth } from "../../Context/AuthContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { EbookQuickOrderLineEntry } from "./ebookQuickOrderLineEntry";
import { QuickOrderLineEntry } from "../QuickOrder/quickOrdSidePopup/QuickOrderLineEntry";
import { EmptyCart } from "../../Layout/Common/emptyCart";
import { QuickOrderMyCard } from "../QuickOrder/quickOrdSidePopup/QuickOrderMyCard";
import { MyCartSideSkeleton } from "../../Skeleton/myCartSideSkeleton";
import { QuickOrderOrderDetails } from "../QuickOrder/quickOrdSidePopup/QuickOrderOrderDetails";
import { QuickOrderCopyPast } from "../QuickOrder/quickOrdSidePopup/QuickOrderCopyPast";
import { QuickOrderExcel } from "../QuickOrder/quickOrdSidePopup/QuickOrderExcel";
import { useFlashLoaderLoader } from "../../Context/FlashScreenContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import $ from "jquery";
import { ProductEntryContainer } from "./EbookProductEntry/productEntryContainer";

export const EbookMain = () => {
  const { ebookpath } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const globalcontext = useContext(GlobalContext);
  const { CartItem, setCartItem } = useContext(GlobalContext);
  const { isAuthenticated, userId } = useAuth();
  const offcanvasRef = useRef(null);
  const closeRef = useRef(null);
  const location = useLocation();
  const path = location?.pathname?.toLowerCase() || "";
  const { addToCardQuickOrder, refreshCartItem } = useGlobalFunction();
  const [isEbookView, setIsEbookView] = useState(false); //path.includes("view_ebook");

  const [isLineEntry, setIsLineEntry] = useState(true);
  const [isCopyPaste, setIsCopyPaste] = useState(false);
  const [isExcelUpload, setIsExcelUpload] = useState(false);
  const { showNoteAlert } = useNoteAlert();
  const [htmlSource, setHtmlSource] = useState("");
  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;

  const handleNavigation = () => {
    if (closeRef.current) {
      closeRef.current.click();
    }
  };
  useEffect(() => {
    handleNavigation();
    var ebookPath = base64Decode(ebookpath);
    if (ebookPath && !ebookPath.endsWith("/")) ebookPath = ebookPath + "/";
    setHtmlSource("/document/" + ebookPath + "index.html");
  }, [location]);

  useEffect(() => {
    if (isOpen && closeRef.current) {
      closeRef.current.click();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsOpen(false);
    }
    refreshCartItem();
  }, [isAuthenticated]);

  useEffect(() => {
    const root = document.getElementById("root");
    const mainWrapper = document.querySelector(".main-wrapper");
    const footerSection = document.querySelector(".footer-section");
    const quickLinksSection = document.querySelector(".quick-links-sections");

    const previousMainWrapperDisplay = mainWrapper ? mainWrapper.style.display : "";
    const previousFooterDisplay = footerSection ? footerSection.style.display : "";
    const hadQuickLinksDNone = quickLinksSection ? quickLinksSection.classList.contains("d-none") : false;
    const hadQuickLinksDLgBlock = quickLinksSection ? quickLinksSection.classList.contains("d-lg-block") : false;
    root.classList.add("no-top-padding");

    if (mainWrapper) {
      mainWrapper.style.display = "none";
    }
    if (footerSection) {
      footerSection.style.display = "none";
    }
    if (quickLinksSection) {
      quickLinksSection.classList.remove("d-lg-block");
      quickLinksSection.classList.add("d-none");
    }

    return () => {
      root.classList.remove("no-top-padding");
      if (mainWrapper) {
        mainWrapper.style.display = previousMainWrapperDisplay;
      }
      if (footerSection) {
        footerSection.style.display = previousFooterDisplay;
      }
      if (quickLinksSection) {
        if (hadQuickLinksDLgBlock) {
          quickLinksSection.classList.add("d-lg-block");
        }
        if (!hadQuickLinksDNone) {
          quickLinksSection.classList.remove("d-none");
        }
      }
    };
  }, []);

  const { showLoader, hideLoader } = useFlashLoaderLoader();

  const handleOpenSidePanel = () => {
    setIsOpen(true);
    let sideNaveWidth = $("#quickOrder-popup").width();
    $("#iframe_ebook").css("width", `calc(100% - ${sideNaveWidth}px)`);
  };

  const handleCloseSidePanel = () => {
    setIsOpen(false);
    $("#iframe_ebook").css("width", "100%");
  };
  const AddItemCart = async (data, callback) => {
    if (isValidArray(data)) {
      showLoader();
      var response = await addToCardQuickOrder({
        userId: userId,
        itemList: data,
      });
      if (response) {
        if (response && response.data) globalcontext.setCartItem(response.data);
        callback(response.errorItem);
        hideLoader();
      } else {
        hideLoader();
      }
    }
  };

  return (
    <Fragment>
      <div className="" id="divebook">
        <div
          className="span8 box1"
          id="main"
          style={{
            width: "-webkit-fill-available",
            width: "-moz-available",
            background: "#eef0ef",
          }}
        >
          <div style={{ display: "flex", width: "100%", height: "100vh", position: "relative" }}>
            <iframe
              frameBorder="0"
              id="iframe_ebook"
              scrolling="no"
              style={{
                border: "0",
                width: "100%",
              }}
              src={htmlSource}
              title="Iframe Example"
            />

            {/* SIDE PANEL */}
            <div
              id="quickOrder-popup"
              role="dialog"
              className={`offcanvas offcanvas-end ${isOpen ? "show" : ""}`}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                visibility: isOpen ? "visible" : "hidden",
                position: "absolute",
              }}
            >
              <div className="offcanvas-header cartPopup-header">
                <h5 id="offcanvasTopLabel">Quick Order</h5>
                <div className="quickorder-cart" id="ebook-quickorder-cart">
                  <div
                    className="header-user header-cart d-flex"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#cartPopup"
                    aria-controls="offcanvasTop"
                  >
                    <a className="cart-icon">
                      <span className="wes-cart"></span>
                    </a>
                    <div className="header-cart shopping-cart">
                      <a>{CartItem == null ? "0" : CartItem.totalItem}</a>
                    </div>
                  </div>
                  <p
                    className="text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={handleCloseSidePanel}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </p>
                </div>
              </div>
              <div className="offcanvas-body cartPopup-body" style={{ flex: 1, overflowY: "auto" }}>
                <div className="quickOrderList quick_orders">
                  <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${isLineEntry ? "active" : ""}`}
                        id="pills-productLine-tab"
                        type="button"
                        role="tab"
                        onClick={() => {
                          setIsLineEntry(true);
                          setIsCopyPaste(false);
                          setIsExcelUpload(false);
                        }}
                      >
                        <span className="wes-product-line"></span>
                        <span className="quickCart-title">Product Line Entry</span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${isCopyPaste ? "active" : ""}`}
                        id="pills-copyPaste-tab"
                        type="button"
                        role="tab"
                        tabIndex="-1"
                        onClick={() => {
                          setIsLineEntry(false);
                          setIsCopyPaste(true);
                          setIsExcelUpload(false);
                        }}
                      >
                        <span className="wes-copy-paste"></span>{" "}
                        <span className="quickCart-title">Copy &amp; Paste</span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${isExcelUpload ? "active" : ""}`}
                        id="pills-excelUpload-tab"
                        type="button"
                        role="tab"
                        tabIndex="-1"
                        onClick={() => {
                          setIsLineEntry(false);
                          setIsCopyPaste(false);
                          setIsExcelUpload(true);
                        }}
                      >
                        <span className="wes-excel-upload"></span> <span className="quickCart-title">Excel Upload</span>
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {isLineEntry && <ProductEntryContainer />}
                    {isCopyPaste && (
                      <div
                        className="tab-pane fade active show"
                        id="pills-copyPaste"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                      >
                        <div className="container">
                          <div className="row">
                            <QuickOrderCopyPast AddtoCart={AddItemCart} />
                          </div>
                        </div>
                      </div>
                    )}
                    {isExcelUpload && (
                      <div className="tab-pane fade active show" id="pills-excelUpload" role="tabpanel">
                        <div className="container">
                          <div className="row">
                            <QuickOrderExcel AddtoCart={AddItemCart} />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="offcanvas-footer quickOrder-footer" style={{ flexShrink: 0 }}>
                <div className="subtotal-btn">
                  <Link to="/OrderDetails" onClick={handleNavigation} className="btn btn-products btn-unavailable">
                    View Cart
                  </Link>

                  <div className="button-effect popup-checkout-btn">
                    <Link onClick={handleNavigation} to="/Checkout" className="btn btn-products btn-addcart green-btn">
                      Checkout
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {!isOpen && userId && false && (
              <div
                style={{
                  width: "50px",
                  background: "#8bc34a",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "opacity 0.3s ease",
                }}
                onClick={handleOpenSidePanel}
              >
                <i className="bi bi-arrow-left-circle-fill" />
                <div>Open</div>
              </div>
            )}
            {!isOpen && userId && (
              <div id="open_icon" style={{ display: "block" }}>
                <span id="opennav" onClick={handleOpenSidePanel}>
                  <svg
                    xmlns="https://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    fill="currentColor"
                    className="bi bi-arrow-left-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
                  </svg>
                  <div className="open_text">Open</div>
                  <h4>Price Check &amp; Order</h4>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
